import useApiAtendimento from "./atendimento";

export const useFetchEntidade = (id, tipo) => useApiAtendimento(`/${tipo}/${id}`);

export const useFetchAll = (tipo) => useApiAtendimento(`/${tipo}`);